// extracted by mini-css-extract-plugin
export default {"container":"Login_container__XiMTb","form":"Login_form__xawx9","formGroup":"Login_formGroup__Jw-2v","submitButton":"Login_submitButton__YVzz-","message":"Login_message__1ICkT"};